// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1d0b2961","239":"87a7801e","453":"424c2a46","667":"aa5f1513","879":"14d90d0f"}[chunkId] + ".chunk.js";
};